import React, { Component } from "react";
import { withRouter } from "react-router";
import Request from "superagent";

import { API_BASE } from "./api";

class GameStarter extends Component {
  componentDidMount() {
    const { router, params: { gameId } } = this.props;
    // TODO resume?

    const data = { game: gameId };
    Request.post(`${API_BASE}/lobbies`)
      .send(data)
      .end((err, res) => {
        if (err) {
          alert("Could not create game lobby"); // TODO ERROR HANDLING
          return;
        }
        router.replace(`/lobby/${gameId}-${res.body.code}`);
      });
  }

  render() {
    // TODO spinner
    return <div />;
  }
}
export default withRouter(GameStarter);



// WEBPACK FOOTER //
// ./src/GameStarter.js